module.exports = __webpack_public_path__ + "img/16.19b6f41.svg";